import stream from 'mithril/stream'
import React, {Component, Fragment} from 'react'
import {FBPTracking, GATracking, GTMTracking} from 'util/trackers'

// tslint:disable:no-string-literal
export class Tracking extends Component<{
	view: any // ClassComponents<{cookies: boolean}>
	project: string
}> {
	cookies = stream(
		localStorage ? !!localStorage.getItem('acceptedCookies') : false
	)
	componentDidMount() {
		this.cookies.map(accept => {
			if (localStorage) {
				if (accept) localStorage.setItem('acceptedCookies', 'true')
				else localStorage.removeItem('acceptedCookies')
			}
		})
	}
	render() {
		const {view: Cookiewarning} = this.props
		const acceptedCookies = this.cookies()
		const gaCode = window['__GA_TRACKING__']
		const gtmCode =
			this.props.project === 'futuresummits'
				? window['__FS_GTM_TRACKING__']
				: window['__ITF_GTM_TRACKING__']
		const fbCode = window['__FB_PIXEL_TRACKING__']
		return (
			<Fragment>
				<Cookiewarning cookies={this.cookies} />
				{gaCode && <GATracking id={gaCode} acceptedCookies={acceptedCookies} />}
				{gtmCode && (
					<GTMTracking id={gtmCode} acceptedCookies={acceptedCookies} />
				)}
				{fbCode && (
					<FBPTracking id={fbCode} acceptedCookies={acceptedCookies} />
				)}
			</Fragment>
		)
	}
}
